
class WindowUtils {

    static isWindowLocation(currUrl: string) {
        return window.location.pathname === currUrl;
    }
}

export default WindowUtils;